import * as React from 'react'

function AutoRefills({
	className, stroke = '#000000', ...props
}) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 21 10" className={className} {...props}>
			<g
				stroke={stroke}
				fill="none"
				fillRule="evenodd"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M12.759 0L12 3.282 15 4" />
				<path d="M12.445 2.863C14.46.884 16.142 1 16.142 1 18.272 1.001 20 2.79 20 4.996c-.057 2.181-1.751 3.936-3.858 3.995-1.54.117-2.84-.88-3.853-1.916-1.19-1.217-3.051-3.793-4.51-4.966A4.555 4.555 0 004.857 1c-1.378 0-2.652.762-3.341 1.998a4.118 4.118 0 000 3.994C2.206 8.23 3.48 8.991 4.858 8.991c0 0 1.607.198 3.648-1.768" />
			</g>
		</svg>
	)
}

export default AutoRefills;

